import _slicedToArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { Fragment } from 'react';
import { useTranslation } from 'next-i18next';
import { connect } from 'react-redux';
import { getSubunitCountInUnit, findUnit } from '@spa/shared/utils/transformers';
import { describeLivingWith } from '@spa/offer/utils/transformers/translations';
import ReadMoreInline from '@spa/shared/components/ReadMoreInline';
import { Title, Wrapper, Subtitle, LivingWith } from './styles';
import { RENT_TYPE } from '@spa/shared/constants/rentType';
import EnergyCertification from '../EnergyCertification';
var AboutThisPlace = function AboutThisPlace(_ref) {
  var propertyDescription = _ref.propertyDescription,
    isRentByProperty = _ref.isRentByProperty,
    numberOfRoommates = _ref.numberOfRoommates,
    landlordResident = _ref.landlordResident,
    propertyGenderRestriction = _ref.propertyGenderRestriction,
    propertyType = _ref.propertyType;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return __jsx(Wrapper, null, __jsx(Title, null, "".concat(t("About this ".concat(propertyType)))), propertyDescription && __jsx(ReadMoreInline, {
    text: propertyDescription
  }), __jsx(EnergyCertification, null), !isRentByProperty && __jsx(Fragment, null, __jsx(Subtitle, null, t('You will be living with...')), __jsx(LivingWith, null, describeLivingWith({
    t: t,
    numberOfRoommates: numberOfRoommates,
    propertyGenderRestriction: propertyGenderRestriction,
    landlordResident: landlordResident
  }).map(function (_ref2) {
    var translation = _ref2.translation,
      Icon = _ref2.icon;
    return __jsx("div", {
      key: translation
    }, __jsx(Icon, null), __jsx("span", null, translation));
  }))));
};
var mapStateToProps = function mapStateToProps(_ref3) {
  var _ref3$offer$offerAggr = _ref3.offer.offerAggregate,
    _ref3$offer$offerAggr2 = _ref3$offer$offerAggr.property_aggregate.property,
    landlordResident = _ref3$offer$offerAggr2.landlord_resident,
    floors = _ref3$offer$offerAggr2.floors,
    rentBy = _ref3$offer$offerAggr2.lifecycle.rent_by,
    propertyType = _ref3$offer$offerAggr2.typology.type_code,
    propertyGenderRestriction = _ref3$offer$offerAggr2.restrictions.gender,
    _ref3$offer$offerAggr3 = _ref3$offer$offerAggr.accommodation_offer.property,
    unitId = _ref3$offer$offerAggr3.unit_id,
    unitType = _ref3$offer$offerAggr3.unit_type;
  var _floors = _slicedToArray(floors, 1),
    floor = _floors[0];
  var unit = findUnit(floor.units, unitId);
  var numberOfRoommates = rentBy === RENT_TYPE.BED && unit ? getSubunitCountInUnit(unit, unitType) : null;
  return {
    numberOfRoommates: numberOfRoommates,
    propertyGenderRestriction: propertyGenderRestriction,
    landlordResident: landlordResident,
    propertyType: propertyType
  };
};
export default connect(mapStateToProps)(AboutThisPlace);